import * as actionTypes from "utils/redux/action";

export const initialState = {
  drawer: false,
  index: 0,
  position: 5,
};

const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.NAVIGATION_SET_MENU:
      return {
        ...state,
        index: action.index,
        position: (() => {
          switch (action.index) {
            case 1:
              return 108;
            case 2:
              return 235;
            case 3:
              return 342;
            default:
              return 5;
          }
        })(),
      };

    case actionTypes.NAVIGATION_TOGGLE_DRAWER:
      return {
        ...state,
        drawer: action.drawer,
      };

    default:
      return state;
  }
};

export default navigationReducer;
